import {EVOUCHER_UPDATE_LOGS} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  selectedData: null,
  formType: "",
  formTitle: "",
  formId: "",

  showModalConfig: false,
  isSavingConfig: false,
  isLoadingConfig: false,
  isActive: false
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case EVOUCHER_UPDATE_LOGS:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/EVoucherUpdateLogs.js